/* eslint-disable no-console -- opt-in debug logging gated by VITE_LOG_SPREAD_XML */
import { isSpreadXmlLoggingEnabled } from '@/config/config'
import type { SpreadCheckpoint } from '@/api/types/spread-checkpoint'
import { buildSpreadXml, countSpreadXmlElements } from './helpers/spread-xml'

/**
 * Logs the spread's reconstructed NSD XML once per spread load.
 *
 * Set `VITE_LOG_SPREAD_XML=true` (e.g. in `.env.local`) and reload to enable. The XML is logged as a
 * bare string rather than inside an object so DevTools' "Copy string contents" yields a valid `.xml`
 * file, which is the point - the output is meant to be diffed against `larry-load-api/src/fixtures/*.xml`.
 *
 * The frontend has no XML of its own; see `spread-xml.ts` for how it is rebuilt and what the
 * fidelity limits are.
 */
export function logSpreadXmlDebug(spreadId: string, checkpoint: SpreadCheckpoint): void {
  if (!isSpreadXmlLoggingEnabled()) return

  try {
    const xml = buildSpreadXml(checkpoint.metadata)

    console.groupCollapsed(`[spread-xml] spread ${spreadId} @ ${checkpoint.decodedAt}`)
    console.log(
      `elements: ${countSpreadXmlElements(checkpoint.metadata)}, ${xml.length} chars — reconstructed, not fetched`
    )
    console.log(xml)
    console.groupEnd()
  } catch (error) {
    // A debug dump must never take a spread load down with it.
    console.warn(`[spread-xml] failed to build XML for spread ${spreadId}:`, error)
  }
}
